import { c as _c } from "react/compiler-runtime";
import { FlexColumn, NumberDisplay, TableCell, TableRow, TextBody, TextLabel } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { RECEIPT_TABLE_COLUMN_CLASSNAMES } from "./constants";
export const ReceiptTotalDisplay = t0 => {
  const $ = _c(11);
  const {
    prices,
    label
  } = t0;
  const hasMultipleCurrencies = prices.length > 1;
  const t = useTranslations("wallet.ReceiptTotalDisplay");
  let t1;
  if ($[0] !== hasMultipleCurrencies || $[1] !== label || $[2] !== prices || $[3] !== t) {
    let t2;
    if ($[5] !== hasMultipleCurrencies || $[6] !== label || $[7] !== t) {
      t2 = price => <TableRow key={price.symbol}><TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.item}><TextLabel weight="semibold">{label ?? t("total")}{" "}{hasMultipleCurrencies && `(${price.symbol})`}</TextLabel></TableCell><TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.price}><FlexColumn className="text-right"><TextBody weight="semibold"><NumberDisplay suffix={price.symbol} value={price.unit} /></TextBody><TextBody color="text-secondary" weight="regular"><NumberDisplay display="usd" value={price.usd} /></TextBody></FlexColumn></TableCell></TableRow>;
      $[5] = hasMultipleCurrencies;
      $[6] = label;
      $[7] = t;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = prices.map(t2);
    $[0] = hasMultipleCurrencies;
    $[1] = label;
    $[2] = prices;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <>{t1}</>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};